var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7778 17H2.22223V15L4.16667 14V8.5C4.11545 7.08912 4.42522 5.68913 5.06501 4.44C5.37985 3.86727 5.80918 3.36971 6.32467 2.98015C6.84016 2.59058 7.4301 2.31787 8.05556 2.18V0H11.9445V2.18C14.4518 2.794 15.8333 5.038 15.8333 8.5V14L17.7778 15V17Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2222 17.7778C12.2222 19.0051 11.2273 20.0001 9.99999 20.0001C8.77269 20.0001 7.77777 19.0051 7.77777 17.7778C7.77777 17.7778 8.77269 17.7779 9.99999 17.7779C11.2273 17.7779 12.2222 17.7778 12.2222 17.7778Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.197aa2b733d928de9340d0ca1c107f20.svg";
export { ForwardRef as ReactComponent };